export function normalizeSegmentId(id: number | string): string {
  return String(id).trim().toLowerCase();
}

export type SegmentIdInput = number | string | (number | string)[];

/** Storyblok editor field is a single option; CDP supplies an array. */
export function normalizeSegmentIds(ids?: SegmentIdInput): string[] {
  if (ids === undefined) {
    return [];
  }
  const list = Array.isArray(ids) ? ids : [ids];
  if (!list.length) {
    return [];
  }
  return list.map(normalizeSegmentId).filter((id) => id.length > 0);
}
